var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.79 115.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1b5ea4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.26,91.39c-16.75,0-33.5,0-50.26,0-7.32,0-12-4.67-12.01-11.97C0,56.91,0,34.41,0,11.91,0,4.71,4.73,0,11.95,0c33.63,0,67.27,0,100.9,0,7.22,0,11.94,4.71,11.94,11.92,0,22.5,0,45,0,67.5,0,7.31-4.68,11.97-12.01,11.97-16.84,0-33.68,0-50.52,0ZM26.74,44.57c0,19.67,15.96,35.66,35.57,35.65,19.8,0,35.81-16.02,35.74-35.76-.07-19.59-16.01-35.52-35.57-35.56-19.68-.03-35.73,15.99-35.73,35.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.54,111.47c7.78,0,15.57,0,23.35,0,.43,0,.88-.03,1.3.03,1.07.16,1.73.78,1.87,1.87.14,1.13-.32,1.98-1.41,2.35-.52.18-1.11.19-1.66.19-15.74,0-31.48,0-47.22,0-.52,0-1.06,0-1.54-.15-1.09-.34-1.61-1.15-1.51-2.29.1-1.15.78-1.81,1.91-1.97.43-.06.87-.03,1.3-.03,7.87,0,15.74,0,23.61,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.67,106.97h-24.48c2.2-3.41,3.45-7,3.37-11.04h17.64c0,3.93,1.08,7.57,3.47,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.19,57.89c-.49-3.64-.98-7.26-1.49-11.01h13.38v11.01h-11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.72,46.87h13.12c.05,3.73-.61,7.33-1.41,11h-11.7v-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.71,42.26c.5-3.7.98-7.29,1.46-10.94h11.88v10.94h-13.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.71,42.26v-10.93h11.89c.49,3.58.98,7.2,1.49,10.93h-13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.33,46.87h10.92c.45,3.66.89,7.31,1.35,11.09-2.93,0-5.92.01-8.9-.02-.22,0-.55-.26-.65-.48-1.54-3.33-2.44-6.83-2.72-10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.54,46.87h10.9c-.25,3.75-1.16,7.25-2.71,10.58-.12.25-.59.49-.9.49-2.86.04-5.73.02-8.64.02.45-3.7.89-7.33,1.34-11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.21,31.24c2.98,0,5.93-.01,8.88.03.25,0,.61.33.73.59,1.49,3.27,2.37,6.7,2.64,10.38h-10.92c-.44-3.65-.87-7.26-1.32-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.26,42.27h-11.07c.43-2.14.73-4.23,1.28-6.25.43-1.58.78-3.54,1.89-4.46.92-.76,2.89-.29,4.4-.31,1.6-.03,3.2,0,4.83,0-.45,3.76-.88,7.36-1.33,11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.05,26.68h-10.33c2.15-5.41,4.58-10.34,10.33-12.99v12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.11,26.7h-10.37v-12.99c5.76,2.55,8.14,7.55,10.37,12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.9,62.48h10.18v12.65c-3.61-.19-8.79-7.05-10.18-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.72,62.46h10.14c-.51,4.73-6.41,12.17-10.14,12.72v-12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.09,16.09c-2.09,3.16-3.77,6.48-4.95,10.05-.08.26-.45.59-.7.59-2.42.04-4.84.03-7.59.03,3.55-4.94,7.85-8.46,13.23-10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.81,26.76c-2.58,0-4.96.02-7.34-.03-.28,0-.69-.33-.82-.61-1.58-3.37-3.12-6.75-4.55-9.89,3.25.72,10.2,6.21,12.71,10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.03,73.1c1.53-3.35,3.05-6.73,4.63-10.09.14-.29.63-.57.96-.58,2.34-.05,4.69-.03,7.31-.03-3.46,4.92-7.8,8.38-12.89,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.74,73.07c-5.06-2.24-9.35-5.74-12.9-10.66,2.72,0,5.2-.02,7.68.03.22,0,.52.38.64.65,1.54,3.33,3.06,6.67,4.57,9.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.afea15421d2551eca884c42e0f4bd144.svg";
export { ForwardRef as ReactComponent };